import { render, staticRenderFns } from "./InstrumentInstanceAuditTrailHistory.vue?vue&type=template&id=8ff4013e"
import script from "./InstrumentInstanceAuditTrailHistory.vue?vue&type=script&lang=js"
export * from "./InstrumentInstanceAuditTrailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports